export class Address {
    public place: string;
    public street: string;
    public zipcode: string;
    public city: string;
    public country: string;
    public supplement: string;

    public setAddress(data: any) {
        this.place = data.place;
        this.street = data.street;
        this.zipcode = data.zipcode;
        this.city = data.city;
        this.country = data.country;
        this.supplement = data.supplement;
    }
}
